import * as RouteNames from "@/employee/route-names";
import { CustodianStatementLink } from "@/shared/types";

export const taxLink: CustodianStatementLink = {
    url: "/resources/tax-forms",
    target: "_self"
  };

  export const statementsLink = taxLink;

export const footerTemplate = "HsaBankInvestmentsFooter";

export const investmentRiskDisclaimer = null;

export const profileEditInformationHtml = "";

export const displayMyProfileEditMode = false;

export const loginUrl = "https://user.bendhsa.com/#/hsab-login";

export const logoutRedirectUrl = null;

export const faqTemplate = "HsaBankForms";

export const faqInstructionsTemplate = "";

export const faqLinkAddress = "";

export const displayFaqInstructions = false;

export const displayAdvice = false;

export const displayFaqExternalLinks = false;

export const displayInvestmentsSection = true;

export const disabledRouteRedirectTarget = RouteNames.CashBalance;

export const displaySettingsLinkedAccounts = true;

export const allowEmailEdit = false;

export const priorYearContributionOption = true;

export const allowReimbursement = false;

export const showPendingReimbursements = false;

export const transactionPayrollOneTimeIsAdjustment = true;

export const showAlternateOnboardingCompleteMessage = true;

const disabledRoutesDictionary = {};

const { Contribution,
    HealthcareExpenses,
    HealthcareExpenseClaims,
    HealthcareExpensesUnreimbursed,
    HealthcareExpensesReimbursed,
    HealthcareExpensesUnreviewed,
    EligibleExpenses,
    FindExpenses,
    ViewClaims } = RouteNames;

disabledRoutesDictionary[HealthcareExpenses] = HealthcareExpenses;
disabledRoutesDictionary[HealthcareExpenseClaims] = HealthcareExpenseClaims;
disabledRoutesDictionary[HealthcareExpensesUnreimbursed] = HealthcareExpensesUnreimbursed;
disabledRoutesDictionary[HealthcareExpensesReimbursed] = HealthcareExpensesReimbursed;
disabledRoutesDictionary[HealthcareExpensesUnreviewed] = HealthcareExpensesUnreviewed;
disabledRoutesDictionary[EligibleExpenses] = EligibleExpenses;
disabledRoutesDictionary[FindExpenses] = FindExpenses;
disabledRoutesDictionary[ViewClaims] = ViewClaims;

export const disabledRoutes = disabledRoutesDictionary;

export const feeTemplate = "TermsFeeSchedule";

export const quarterlyPaperStatementFee = 1.5;

export const manageHsaCardsInPortal = true;

export const displayPriorYearContributionDisclaimerCopy = false;

export const displayProjectedContributions = false;

export const allowUserToEditContributions = false;

export const showCashExpensesGraphWidget = false;
export const showExpenseCategoryWidget = false;
export const showExpenseEligibilityWidget = false;
export const showHealthcareExpensesV2 = false;
export const showHsaStoreShopTab = true;

export const displayHealthcareClaims = false;
export const displayPdfForESign = false;

export const displayHealthcareBluebookLink = true;

export const displayFooterLegalSection = false;

export const contactDetailsSetAtBank = false;

export const showChildExpenseRows = false;